import { render, staticRenderFns } from "./BackNavigator.vue?vue&type=template&id=1b3462fe&scoped=true&"
import script from "./BackNavigator.vue?vue&type=script&lang=js&"
export * from "./BackNavigator.vue?vue&type=script&lang=js&"
import style0 from "./BackNavigator.vue?vue&type=style&index=0&id=1b3462fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3462fe",
  null
  
)

export default component.exports